import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DocumentModule, UploadedFileViewModel } from 'src/app/components/core/components/uploader/document_uploader.types';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { EnumCodigosTwTcAcciones } from '../../../../_importacion/solicitudes/types/enum';
import { ProgramaVerificacionViewModel, TwDocumentacionPvCamViewModel } from '../pvcam-datosbasicos.types';
import { ConfigurationService } from '../../../../core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-pvcam-edit',
    templateUrl: './pvcam-edit.component.html',
})
export class PvCamEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() formGroup: FormGroup;
    @Input() pvCam: ProgramaVerificacionViewModel;
    @Input() submitted: boolean;
    @Input() requerirObservaciones: boolean;
    @Output() fileUpload = new EventEmitter<TwDocumentacionPvCamViewModel>();
    @Output() pendingPurge = new EventEmitter<string>(); // En caso que el usuario no guardara la documentación vinculada al fichero adjuntado, el fichero tendrá que ser eliminado de la BD.

    editMode = false;
    editTitle = 'Nuevo';

    uploadedFile: UploadedFileViewModel;
    documentModuleCampania = DocumentModule.Campania;
    megaSizeLimit = 0;

    private fileSuccessMessage = 'Documentación cargada. Recuerde GUARDAR antes de abandonar la pantalla';

    habilitarGuardar = false;
    habilitarEdicion = false;
    visibilitySpinner = false;

    constructor(
        public datepipe: DatePipe,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private cdr: ChangeDetectorRef,
        protected configService: ConfigurationService,
    ) {
        super(authService, notificationService, exceptionHandler, configService);
    }

    ngOnInit(): void {
        this.updateForm();

        this.MegaSizeLimitsCargado$.subscribe(() => {
            this.megaSizeLimit = this.getValorSizeLimit('pvcam-edit');
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.pvCam?.currentValue) {
            this.pvCam = { ...changes.pvCam.currentValue };
            this.uploadedFile = new UploadedFileViewModel();
            if (this.pvCam?.TwDocumentacionPvCam) {
                this.uploadedFile = {
                    ...this.uploadedFile,
                    Guid: this.pvCam?.TwDocumentacionPvCam?.CodigoStorage,
                    Name: this.pvCam?.TwDocumentacionPvCam?.NombreArchivo,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                    Size: this.pvCam?.TwDocumentacionPvCam?.Size!,
                };
            }
            this.updateForm();
        }
    }

    /**
     * This functions sets the values in the periodoCam (@Input) into the form.
     */
    private updateForm(): void {
        if (this.pvCam) {
            this.formGroup.setValue({
                IdPeriodoEntidadAuditoraCam: this.pvCam?.Id || 0,
                IdEstadoPv: this.pvCam?.IdEstadoPv || 0,
                EstadoPv: this.pvCam?.EstadoPv,
                Campania: this.pvCam?.Campania,
                Periodo: this.pvCam?.Periodo,
                ComunidadAutonoma: this.pvCam?.ComunidadAutonoma,
                FechaPresentacion: this.datepipe.transform(this.pvCam?.FechaPresentacion, 'dd/MM/yyyy HH:mm:ss'),
                FechaDevolucion: this.datepipe.transform(this.pvCam?.FechaDevolucion, 'dd/MM/yyyy HH:mm:ss'),
                FechaAdmision: this.datepipe.transform(this.pvCam?.FechaAdmision, 'dd/MM/yyyy HH:mm:ss'),
                Observaciones: this.pvCam?.Observaciones,
                Texto: this.pvCam?.TwDocumentacionPvCam != null ? this.pvCam?.TwDocumentacionPvCam?.Texto : null,
                NombreArchivo: this.pvCam?.TwDocumentacionPvCam != null ? this.pvCam?.TwDocumentacionPvCam?.NombreArchivo : null,
            });
            this.habilitarGuardar =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_PROGRAMA_VERIFICACION, this.pvCam.IdEstadoPv).Editable && this.isEA;
            this.habilitarEdicion = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_PROGRAMA_VERIFICACION,
                this.pvCam.IdEstadoPv,
            ).Editable;
            if (!this.habilitarEdicion) {
                this.DisableControlsConsulta();
            } else {
                this.EnableControlsEdition();
            }
        }
        this.form = this.formGroup; // componentBase uses this.form
        this.cdr.detectChanges();
    }

    private DisableControlsConsulta(): void {
        this.form.controls['Observaciones'].disable();
        this.form.controls['Texto'].disable();
    }

    private EnableControlsEdition(): void {
        //dependiendo del perfil
        if (this.isEA) {
            this.form.controls['Texto'].enable();
            this.form.controls['Observaciones'].disable();
        } else if (this.isCA) {
            this.form.controls['Texto'].disable();
            this.form.controls['Observaciones'].enable();
        }
    }

    onFileUploaded(uploadedFile: UploadedFileViewModel): void {
        this.pvCam.TwDocumentacionPvCam = new TwDocumentacionPvCamViewModel();
        this.pvCam.TwDocumentacionPvCam.IdProgramaVerificacion = this.pvCam.Id;
        this.pvCam.TwDocumentacionPvCam.CodigoStorage = uploadedFile.Guid;
        this.pvCam.TwDocumentacionPvCam.NombreArchivo = uploadedFile.Name;
        //this.pvCam.TwDocumentacionPvCam.Texto = this.form.value.Texto;
        this.pvCam.TwDocumentacionPvCam.Size = uploadedFile.Size;
        this.pvCam.TwDocumentacionPvCam.IdUsuario = this.loggedInUser!.Id;

        this.addSuccessMessage(this.fileSuccessMessage);

        this.fileUpload.emit(this.pvCam.TwDocumentacionPvCam);
        this.pendingPurge.emit(uploadedFile.Guid);

        //en Uploader Local obtenemos el valor para este campo obligatorio en subida local
        this.form.controls['NombreArchivo'].setValue(this.uploadedFile!.Name);
    }

    get ficheroSubido(): boolean {
        return this.uploadedFile.Guid !== undefined && this.uploadedFile.Guid !== null && this.uploadedFile.Guid !== '' && !this.uploadedFile.MarkToDelete;
    }

    onFileDeleted(deletedFile: UploadedFileViewModel) {
        this.uploadedFile = deletedFile;
        this.pendingPurge.emit(deletedFile.Guid);
    }
}
